export default {
  swaggerInterface: '/swagger',
  website: 'https://ergoplatform.org',
  nanoErgInErg: 1000000000,
};
